#!/usr/bin/env node
import { config } from 'dotenv';
import { logger } from "./utils/logger.js";
import { loadConfig } from "./config/loader.js";

// Export processors
export * from "./processors/index.js";

// Export core functionality
export * from "./core/index.js";

// Export utilities
export * from "./utils/index.js";

// Export config loader
export { loadConfig };

// Load environment variables
config();

// Handle uncaught errors
process.on('uncaughtException', (error) => {
  logger.error('Uncaught exception:', error);
  process.exit(1);
});

process.on('unhandledRejection', (error) => {
  logger.error('Unhandled rejection:', error);
  process.exit(1);
});

export async function runWorkflow(workflowPath, options = {}) {
  // ... existing code ...
}

export async function resumeWorkflow(workflowPath, options = {}) {
  // ... existing code ...
}

export async function reviewFile(workflowPath, filePath) {
  // ... existing code ...
}

export async function listFilesAwaitingReview(workflowPath) {
  // ... existing code ...
}

export async function isAwaitingHumanInput(workflowPath) {
  // ... existing code ...
}

// Export logger for external use
export { logger };